'use client';

import { EntityIcon, MetricItem } from '@terra/ui-design-system';

export type ListPageDetectionType = 'signal' | 'finding';

export function ListPageDetectionMetric({
  type,
  count,
  label,
}: {
  type: ListPageDetectionType;
  count: number;
  label: string;
}) {
  const isEmpty = count === 0;

  return (
    <MetricItem
      hideTooltip
      disabled={isEmpty}
      icon={
        <EntityIcon
          type={type}
          appearance={isEmpty ? 'muted' : 'highlighted'}
          density="compact"
        />
      }
      label={label}
      metrics={count}
    />
  );
}
